/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Search_PlaceholderInputs */

const cs_tasks_search_placeholder = /** @type {(inputs: Tasks_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat název`)
};

const en_tasks_search_placeholder = /** @type {(inputs: Tasks_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search title`)
};

/**
* | output |
* | --- |
* | "Search title" |
*
* @param {Tasks_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_search_placeholder = /** @type {((inputs?: Tasks_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_search_placeholder(inputs)
	return cs_tasks_search_placeholder(inputs)
});